import md5 from 'blueimp-md5'
import { loadingService } from '@/utils/loadingService'
export const prefix = 'minifire_payment_'
export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
export const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)

export const isPC = !isMobile

export const getPlatform = () => {
  const isAndroid = /Android/i.test(navigator.userAgent)
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
  if (isAndroid) {
    return 'android'
  }
  if (isIOS) {
    return 'ios'
  }
  return 'pc'
}

export const formatNumber = (number, locale = 'tw') => {
  if (!number) {
    return ''
  }
  if (isNaN(number)) {
    return ''
  }
  number = String(number)
  if (number.length <= 3) {
    return number
  }
  if (locale === 'vi') {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  } else {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}

export const getDeviceId = () => {
  if (localStorage.getItem(`${prefix}deviceId`)) {
    return localStorage.getItem(`${prefix}deviceId`)
  }
  const deviceId = md5(new Date().getTime() + '_' + Math.random())
  localStorage.setItem(`${prefix}deviceId`, deviceId)
  return deviceId
}

export const getSessionId = () => {
  if (sessionStorage.getItem(`${prefix}sessionId`)) {
    return sessionStorage.getItem(`${prefix}sessionId`)
  }
  const sessionId = md5(new Date().getTime() + '_' + getDeviceId())
  sessionStorage.setItem(`${prefix}sessionId`, sessionId)
  return sessionId
}

export const loadScript = (url) => {
  return new Promise((resolve, reject) => {
    loadingService.show()
    const script = document.createElement('script')
    script.src = url
    document.head.appendChild(script)
    script.onload = () => {
      resolve()
      loadingService.hide()
    }
    script.onerror = () => {
      reject()
      loadingService.hide()
    }
  })
}

export const setUser = (user = {}) => {
  try {
    localStorage.setItem(`${prefix}user`, JSON.stringify(user))
  } catch (error) {
    console.error(error)
  }
}

export const getUser = () => {
  const user = localStorage.getItem(`${prefix}user`)
  if (user) {
    try {
      return JSON.parse(user)
    } catch (error) {
      console.error(error)
      return {}
    }
  }
  return {}
}

const historyAccountKey = `${prefix}cpUserHistory`

export const formatHistoryAccountItem = ({ cpUserId, cpNickName }) => {
  return `${cpUserId}-${cpNickName || ''}`
}

export const parseHistoryAccountId = (item) => {
  const index = String(item).indexOf('-')
  if (index === -1) {
    return String(item)
  }
  return String(item).slice(0, index)
}

export const getHistoryAccount = () => {
  try {
    return JSON.parse(localStorage.getItem(historyAccountKey) || '[]')
  } catch (error) {
    console.error(error)
    return []
  }
}

export const setHistoryAccount = (cpUserInfo = {}) => {
  const { cpUserId, cpNickName } = cpUserInfo
  if (!cpUserId) {
    return
  }
  const newItem = formatHistoryAccountItem({ cpUserId, cpNickName })
  let historyAccount = getHistoryAccount().filter(
    (item) => parseHistoryAccountId(item) !== String(cpUserId)
  )
  historyAccount.unshift(newItem)
  if (historyAccount.length > 10) {
    historyAccount = historyAccount.slice(0, 10)
  }
  localStorage.setItem(historyAccountKey, JSON.stringify(historyAccount))
}
export const setActUserInfo = (userInfo = {}) => {
  try {
    if (userInfo) {
      localStorage.setItem(`${prefix}act_user_info`, JSON.stringify(userInfo))
    } else {
      localStorage.removeItem(`${prefix}act_user_info`)
    }
  } catch (error) {
    console.error(error)
  }
}

export const getActUserInfo = () => {
  return JSON.parse(localStorage.getItem(`${prefix}act_user_info`) || '{}') || {}
}
